module.exports = __webpack_public_path__ + "components/Header/logo-small@2x.png?8844262b";


//////////////////
// WEBPACK FOOTER
// ./components/Header/logo-small@2x.png
// module id = 827
// module chunks = 0